module.exports = __webpack_public_path__ + "static/media/male_avatar.7cfd2e61.png";